var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary","pressed":_vm.anmeldung.bezahlt != null,"disabled":_vm.pending},on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.anmeldung.bezahlt == null ? "Nein" : _vm.anmeldung.bezahlt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }